import { BCMSRecord, useBCMSContext, useParams, useRoute, useWorkflowStep } from "@bcm-dev/bcms-vite";
import { UIPrimaryButton } from "components/ui/UIButton";
import { getDefault, getWorkflowSteps } from "components/workflows/AutoPayWorkFlow";
import Classes, { Card, LinkedAccount, Transaction } from "model";
import React from "react";
import { SVGAsset } from "res";

import "./styles.css";

/**
 * @function ActivatedAutopayView
 * @param {STRING} fiName - Sets the FI Name.
 * @param {STRING} acctType - Sets the account type.
 * @param {STRING} acctNum - Sets the last four of the account number.
 * @param {STRING} amount - Sets the autopay amount.
 * @return {React.Component}
 * @exported true
 * @description The main component for ActivatedAutopayView and the second step in the autopay workflow.
 */
export default function ActivatedAutopayView(props) {
    const globalController = useBCMSContext();
    const defaultCard =   globalController.state.branding.options.include_debit_chw23  !== "false" ? "0" : "1";
    const cardID = useParams().cardID ?? defaultCard;
    const card = Card.initByID(cardID);
    const workflowStep = useWorkflowStep(getDefault, getWorkflowSteps);

    const account = LinkedAccount.initByID(workflowStep.getStepState.account.id??0)
    const fiName = account.fi_name ?? "[FI Name]";
    const acctType = account.type ?? "[Account Type]";
    const acctNum = account.last_four_digit_number ?? "[Account Number]";
    const amount = workflowStep.getStepState.amountSelect ?? "[Amount]";
    const navigate = useRoute();
    const next = evt => {
        const newTransaction = Transaction.init({
            "id":Transaction.nextID(),
        "merchant":"18",
        "amount":workflowStep.getStepState.amount,
        "last_four_digit_number":acctNum,
        "routing_number":account.routing_number,
        "status":"Processing",
        "type":acctType,
        "card":cardID,
        account:"0",
        "credit":"true",
        "disputeTransaction":"false",
         "disputeTransactionType":"0",
         purchaseDate:card.date ? card.date.diff(): 1
          })
          
        
        BCMSRecord.batch([
            Transaction.create(newTransaction),
          
         
        ],globalController, Classes);
        navigate(-1)
       
    };
    return (
        <div className="activated-autopay-view">
            <div className="flex-container flex-vertical">
                <div className="flex-width circle-icon">
                    <div className="framed-icon-container">
                        <SVGAsset id="RefreshIcon" />
                    </div>
                </div>
                <div className="flex-width header">
                    <p className="text-center"><b>Autopay Activated</b></p>
                </div>
            </div>
            <div className="flex-container flex-horizontal">
                <div className="flex-width">
                    <p className="grey-label"><span>Financial Institution</span></p>
                </div>
                <div className="flex-width text-right">
                    <p><span>{fiName}</span></p>
                </div>
            </div>
            <div className="flex-container flex-horizontal">
                <div className="flex-width">
                    <p className="grey-label"><span>Account</span></p>
                </div>
                <div className="flex-width text-right">
                    <p><span className="capitalize">{acctType} {acctNum}</span></p>
                </div>
            </div>
            <div className="flex-container flex-horizontal">
                <div className="flex-width">
                    <p className="grey-label"><span>Amount</span></p>
                </div>
                <div className="flex-width text-right">
                    <p><span>{amount}</span></p>
                </div>
            </div>
            <div className="flex-container column-space-around-container button-container">
                <UIPrimaryButton text="OK" onClick={next}/>
            </div>
        </div>
    )
}
